<template>
    <drag-and-drop-endpoints
            :js-plumb-instance="jsPlumbInstance"
            
            :reference-parameters="referenceParameters"
            :endpoint-parameters="endpoints"

            @endpoints-updated="endpointsUpdated"

            @click="eventProxies.click"
            @dblclick="eventProxies.dblclick"
            @contextmenu="eventProxies.contextmenu"
            @mouseover="eventProxies.mouseover"
            @mouseout="eventProxies.mouseout"
            @mousedown="eventProxies.mousedown"
            @mouseup="eventProxies.mouseup"
            @maxConnections="eventProxies.maxConnections"
    >
        <slot />
    </drag-and-drop-endpoints>
</template>

<script>
    import journeyBrickEndpointUuidMixin from '@modules/JourneyBuilder/Mixins/journey-brick-endpoint-uuid';
    import journeyBrickEndpointsMixin from '@modules/JourneyBuilder/Mixins/journey-brick-endpoints';

    import DragAndDropEndpoints from "@core/Components/DragAndDrop/DragAndDropEndpoints.vue";

    export default {
        name: 'brick-circle-endpoints',
        components: {
            DragAndDropEndpoints
        },
        mixins: [journeyBrickEndpointUuidMixin, journeyBrickEndpointsMixin],
        created() {
            const vm = this;
            
            //Hide our endpoints
            vm.referenceParameters.endpoint = 'Blank';
            
            vm.sourceEndpointId = vm.getCircleEndpointUuid(vm.connection.id, vm.sourceBrickId);
            vm.destinationEndpointId = vm.getCircleEndpointUuid(vm.connection.id, vm.destinationBrickId);
        },
        methods: {
            endpointsUpdated($event){
                this.$emit('endpoints-updated', $event);

                //Our endpoints-updated event might destroy some endpoints
                //to avoid painting nothing; wait until the next tick
                this.$nextTick(() => this.applyConnectorStrokeColor());
            },
            applyConnectorStrokeColor(){
                const vm = this;
                const el = vm.$el;
                const jsPlumbInstance = vm.jsPlumbInstance;
                
                const stroke = vm.connectorStroke;

                jsPlumbInstance.batch(() => {
                    jsPlumbInstance.getEndpoints(el).forEach(endpoint => {
                        endpoint.connections.forEach(connection => {
                            //Re-use our old style; we only want to re-color
                            //When two endpoints belong to the same element;
                            //JsPlumb might return the same style object for all endpoints
                            //Create a new object to ensure we don't screw ourselves
                            const paintStyle = Object.assign({}, connection.getPaintStyle());
                            paintStyle.stroke = stroke;
                            connection.setPaintStyle(paintStyle);
                        });
                    });
                });
            }
        },
        watch: {
            connectorStroke(){
                this.applyConnectorStrokeColor();
            },
            // async isActive(){
            //     //Wait for our element to resize
            //     await this.$nextTick();
            //
            //     //isActive also toggles the size of our element; we'll need to repaint our connections
            //     //to ensure correct positioning
            //     //Not the most efficient way of handling things
            //     //but will guarantee we won't end up with 'drifting' lines upon resizing
            //     this.jsPlumbInstance.repaintEverything();
            // },
            async 'connection.config.checkpoints'(){
                //Wait for new checkpoints to be rendered
                await this.$nextTick();
                
                //Repaint our UI to connect our connectors to the now resized element
                this.jsPlumbInstance.repaintEverything();
            }
        },
        computed: {
            endpoints(){
                const vm = this;

                //Connections should not be detacheable, they'll get removed once the user removes
                //the circle brick
                
                return [{
                    uuid: vm.sourceEndpointId,
                    isTarget: true,
                    detachable: false
                }, {
                    uuid: vm.destinationEndpointId,
                    isSource: true,
                    detachable: false
                }];
            },
            connectorStroke(){
                return this.isActive ?
                    this.enabledConnectorStroke :
                    this.disabledConnectorStroke;
            }
        },
        data: () => ({
            referenceParameters: null,
            sourceEndpointId: '',
            destinationEndpointId: ''
        }),
        props: {
            connection: {
                type: Object,
                required: true
            },
            isActive: {
                type: Boolean,
                required: true
            },
            sourceBrickId: {
                type: String,
                required: true
            },
            destinationBrickId: {
                type: String,
                required: true
            }
        }
    }
</script>
